import React, { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Typography } from "antd";
import { SbTabs } from "uiCore";
import SbButton from "uiCore/SbButton/SbButton";
import SbJdCreationDrawerV2 from "Components/SbJdCreationDrawerV2/SbJdCreationDrawerV2";
import SbBulkJdUpload from "Pages/SbBulkJdUpload/SbBulkJdUpload";
import { JD_ACTION } from "constants/jobs.constants";
import { useSelector, useDispatch } from "react-redux";
import { showSbConfirm } from "Utils/sbModal";
import { hideToast } from "Store/actions/profileListActions";
import ToasterModal from "Components/SbErrorToasterComponent/SbErrorToaster";

import {
  PageContainer,
  HeaderSection,
  HeaderTopRow,
  TabsRow,
  ContentSection,
  DrawerClosedSection,
  PlaceholderText,
} from "./SbUploadJd.styles";
import AdminPageHeader from "Pages/AdminSetup/components/AdminPageHeader";


const UPLOAD_JD_TABS = [
  { key: "upload-external-jd", label: "Upload External JD" },
  { key: "bulk-jd-upload", label: "Bulk JD Upload" },
];

const SbUploadJd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { show, message, type: toastType } = useSelector((s) => s.profileList.toast);
  const [activeTab, setActiveTab] = useState("upload-external-jd");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isBulkDirty, setIsBulkDirty] = useState(false);

  const tabItems = UPLOAD_JD_TABS.map((tab) => ({ key: tab.key, label: tab.label }));

  const handleBulkDirtyChange = useCallback((dirty) => {
    setIsBulkDirty(dirty);
  }, []);

  const switchTab = (key) => {
    setActiveTab(key);
    setIsDrawerOpen(false);
  };

  const handleTabChange = (key) => {
    if (activeTab === "bulk-jd-upload" && isBulkDirty) {
      showSbConfirm({
        title: "Unsaved data",
        content: "You have unsaved rows. Switching tabs will discard your changes. Continue?",
        okText: "Discard & Switch",
        cancelText: "Stay",
        onOk: () => switchTab(key),
      });
      return;
    }
    switchTab(key);
  };

  const handleBack = () => {
    if (activeTab === "bulk-jd-upload" && isBulkDirty) {
      showSbConfirm({
        title: "Unsaved data",
        content: "You have unsaved rows. Leaving this page will discard your changes.",
        okText: "Leave anyway",
        cancelText: "Stay",
        onOk: () => navigate("/profile"),
      });
      return;
    }
    navigate("/profile");
  };

  return (
    <PageContainer>
      <HeaderSection>
        <HeaderTopRow>
           <AdminPageHeader title="Upload JD" onBack={handleBack} />
        </HeaderTopRow>

        <TabsRow>
          <SbTabs
            activeKey={activeTab}
            onChange={handleTabChange}
            items={tabItems}
          />
        </TabsRow>
      </HeaderSection>

      <ContentSection>
        {activeTab === "upload-external-jd" && (
          <>
            {!isDrawerOpen && (
              <DrawerClosedSection>
                <PlaceholderText>Upload a single external job description.</PlaceholderText>
                <SbButton buttonType="primary" onClick={() => setIsDrawerOpen(true)}>
                  Single Upload
                </SbButton>
              </DrawerClosedSection>
            )}
            <SbJdCreationDrawerV2
              jdActionSelection={JD_ACTION.UPLOAD}
              isDrawerOpen={isDrawerOpen}
              toggleDrawer={() => setIsDrawerOpen(false)}
              setPendingJdId={() => {}}
            />
          </>
        )}

        {activeTab === "bulk-jd-upload" && (
          <SbBulkJdUpload embedded onDirtyChange={handleBulkDirtyChange} />
        )}
      </ContentSection>

      <ToasterModal
        message={message}
        show={show}
        type={toastType}
        onClose={() => dispatch(hideToast())}
      />
    </PageContainer>
  );
};

export default SbUploadJd;
